import React from 'react';
import {Container} from "reactstrap";
import {useQuery} from "react-query";
import http from "../Services/Network/http";
import {useParams} from "react-router-dom";
import Loader from "react-loader-spinner";
import {ProductItem} from "../components/ProductItem";
import { useTranslation } from "react-i18next";
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material'; 

export const Products = () => {
    const { id } = useParams();
    const { data: products, isLoading } = useQuery(
        ["fetchProducts", id],
        () => http.get(`/Product/GetProducts/${id ?? ""}`))

    const [gender, setGender] = React.useState('null');
    const handleChange = (event) => {
        setGender(event.target.value);
    };

    const { data: latestVariantSizes } = useQuery(
        ["fetchLatestVariants"],
        () => http.get(`/Account/GetLatestVariants`))

    const [t] = useTranslation('base');
    return (
        <div>
            <Container>
                <h2 style={{ float: "left", margin:0 }} >{t('product.products')}</h2>
                
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small" style={{float: "right", margin:0}}>
                    <InputLabel id="genderFilterLabel">Gender</InputLabel>
                    <Select
                        labelId="genderFilterLabel"
                        id="genderFilter"
                        label="Gender"
                        onChange={handleChange}
                        value={gender}>
                        <MenuItem value={'null'}>Alle</MenuItem>
                        <MenuItem value={'2'}>Unisex</MenuItem>
                        <MenuItem value={'0'}>Male</MenuItem>
                        <MenuItem value={'1'}>Female</MenuItem>
                    </Select>
                </FormControl>
                <div className="clearfix"></div>
                <hr />
                {isLoading && (
                    <Loader
                        type="ThreeDots"
                        color="#000"
                        height={30}
                        width={30}
                    />
                )}
                {(products || []).filter(x => parseInt(x.gender) === parseInt(gender) || gender === 'null').map((product, index) => (
                    <div key={product.productId}>
                        <ProductItem key={index} product={product} latestVariantSize={latestVariantSizes?.filter(function(item) {return item.productId === product.productId})[0]}  disabled={false}/>
                        <hr/>
                    </div>
                ))}
            </Container>
        </div>
    );
}
